import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { MailIcon, LockIcon, EyeIcon, EyeOffIcon } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { Input } from '../components/ui/Input';
import { Button } from '../components/ui/Button';
import { Card } from '../components/ui/Card';
export function LoginPage() {
  const navigate = useNavigate();
  const {
    login
  } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);
    try {
      const success = await login(email, password);
      if (success) {
        navigate('/account');
      } else {
        setError('Invalid email or password');
      }
    } catch {
      setError('An error occurred. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };
  return <div className="min-h-screen bg-gray-50 flex items-center justify-center py-12 px-4" data-id="element-1324">
      <div className="w-full max-w-md" data-id="element-1325">
        {/* Logo */}
        <div className="text-center mb-8" data-id="element-1326">
          <Link to="/" className="inline-flex items-center gap-2" data-id="element-1327">
            <img src="https://cdn.magicpatterns.com/uploads/fRsBpVfPoCHsQawYgHjccg/ChatGPT_Image_Mar_6,_2026,_03_48_02_AM.png" alt="Gadgets Zone" className="h-12 w-auto object-contain" data-id="element-1328" />
            <span className="text-2xl font-bold text-gray-900" data-id="element-1329">
              Gadgets Zone
            </span>
          </Link>
        </div>

        <Card padding="lg" data-id="element-1330">
          <h1 className="text-2xl font-bold text-gray-900 text-center mb-2" data-id="element-1331">
            Welcome Back
          </h1>
          <p className="text-gray-600 text-center mb-6" data-id="element-1332">
            Sign in to your account to continue
          </p>

          {error && <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-lg text-red-600 text-sm" data-id="element-1333">
              {error}
            </div>}

          <form onSubmit={handleSubmit} className="space-y-4" data-id="element-1334">
            <Input label="Email Address" type="email" placeholder="your@email.com" value={email} onChange={e => setEmail(e.target.value)} leftIcon={<MailIcon className="w-5 h-5" data-id="element-1336" />} required data-id="element-1335" />

            <div className="relative" data-id="element-1337">
              <Input label="Password" type={showPassword ? 'text' : 'password'} placeholder="Enter your password" value={password} onChange={e => setPassword(e.target.value)} leftIcon={<LockIcon className="w-5 h-5" data-id="element-1339" />} rightIcon={<button type="button" onClick={() => setShowPassword(!showPassword)} className="text-gray-400 hover:text-gray-600" data-id="element-1340">
                    {showPassword ? <EyeOffIcon className="w-5 h-5" data-id="element-1341" /> : <EyeIcon className="w-5 h-5" data-id="element-1342" />}
                  </button>} required data-id="element-1338" />
            </div>

            <div className="flex items-center justify-between" data-id="element-1343">
              <label className="flex items-center gap-2 cursor-pointer" data-id="element-1344">
                <input type="checkbox" className="w-4 h-4 text-primary-600 rounded" data-id="element-1345" />
                <span className="text-sm text-gray-600" data-id="element-1346">Remember me</span>
              </label>
              <Link to="/forgot-password" className="text-sm text-primary-600 hover:text-primary-700" data-id="element-1347">
                Forgot password?
              </Link>
            </div>

            <Button type="submit" variant="primary" size="lg" fullWidth isLoading={isLoading} data-id="element-1348">
              Sign In
            </Button>
          </form>

          <div className="mt-6 text-center" data-id="element-1349">
            <p className="text-gray-600" data-id="element-1350">
              Don't have an account?{' '}
              <Link to="/register" className="text-primary-600 hover:text-primary-700 font-medium" data-id="element-1351">
                Create Account
              </Link>
            </p>
          </div>
        </Card>

        <p className="mt-6 text-center text-sm text-gray-500" data-id="element-1352">
          Demo: Enter any email and password to login
        </p>
      </div>
    </div>;
}